module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.33402/images/pngs/homepage-hero-assistant.png"